import {
  Button as StyledButton,
  IconWrapper,
  TitleWrapper,
  SsoProviderImage,
} from './SsoLoginButton.styled'

type SsoLoginButtonProps = {
  title: string
  iconUrl?: Nullable<string>
  dataTest?: string
  disabled?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  uppercase?: boolean
  hint?: string
}

const SsoLoginButton: React.FC<SsoLoginButtonProps> = props => {
  const { title, disabled, onClick, dataTest, hint, iconUrl } = props

  return (
    <StyledButton
      type='button'
      disabled={disabled}
      onClick={onClick}
      data-test={dataTest}
      title={hint}
    >
      {iconUrl && (
        <IconWrapper>
          <SsoProviderImage src={iconUrl} />
        </IconWrapper>
      )}
      <TitleWrapper data-test='ButtonTitle'>{title}</TitleWrapper>
    </StyledButton>
  )
}

export default SsoLoginButton
